<div class="contacts_wrapper">
  <h3 class="contacts_header" i18n="@@contactdetails">
    Contact
  </h3>
  <div class="contacts_content">
    <p class="contact-detail-row" *ngIf="isEnabled('mobile')">
      <svg width="20px" height="20px">
        <use xlink:href="#phone"></use>
      </svg>
      <span class="contact-detail">
        <a class="text-link_custom" href="tel:{{ contacts?.mobile.number }}">{{ contacts?.mobile.number }}</a>
      </span>
    </p>

    <p class="contact-detail-row" *ngIf="isEnabled('email')">
      <svg width="20px" height="20px">
        <use xlink:href="#email"></use>
      </svg>

      <span class="contact-detail"><a class="text-link_custom" href="mailto:{{ contacts?.email.email }}"> {{ contacts?.email.email }}</a></span>
    </p>

    <p class="contact-detail-row" *ngIf="isEnabled('address')">
      <svg width="20px" height="20px">
        <use xlink:href="#location"></use>
      </svg>
      <span class="contact-detail">{{ contacts?.address.line1 }} {{ contacts?.address.houseNumber }}</span>
    </p>

    <p class="contact-detail-row" *ngIf="isEnabled('address')">
      <svg width="20px" height="20px" class="invisible">
        <use xlink:href="#location"></use>
      </svg>
      <span class="contact-detail"> {{ contacts?.address.postalCode }} {{ contacts?.address.city }}</span>
    </p>

    <div class="social-media-contact">
      <a [href]="contacts?.linkedin.url" target="_blank" *ngIf="isEnabled('linkedin')" [style.order]="contacts?.linkedin.order">
        <svg width="20px" height="20px">
          <use xlink:href="#linkedin"></use>
        </svg>
      </a>

      <a [href]="contacts?.facebook.url" target="_blank" *ngIf="isEnabled('facebook')" [style.order]="contacts?.facebook.order">
        <svg width="20px" height="20px">
          <use xlink:href="#facebook"></use>
        </svg>
      </a>

      <a [href]="contacts?.instagram.url" target="_blank" *ngIf="isEnabled('instagram')" [style.order]="contacts?.instagram.order">
        <svg width="20px" height="20px">
          <use xlink:href="#instagram"></use>
        </svg>
      </a>

      <a [href]="contacts?.twitter.url" target="_blank" *ngIf="isEnabled('twitter')" [style.order]="contacts?.twitter.order">
          <svg width="20px" height="20px">
          <use xlink:href="#twitter"></use>
        </svg>
      </a>
    </div>
  </div>
</div>
